(function($){

	$(document).ready(function(){
		
		$(document).on('click','.single .entry-header .image-wrapper .featured-image.is-video', function(e){
			
			$featured_video = this.parentElement.querySelector('.featured-video');
			$featured_video.play();
			$(this).siblings('.play-icon').hide();
			$(this).hide();

		});

		$(document).on('click','.social-share__trigger',function(e){
			e.preventDefault();
			$(this).siblings('.social-share').slideToggle();
		});

		$(document).on('click','.menu-social-share .copy-link', function(e){ 
        	e.preventDefault();
        	var url = $(this).attr('href');
        	copyLink(url); 
    	});

    	$(document).on('click','.album-content__block .js-load-more',function(e){
    		e.preventDefault();
    		$grid = $(this).parent().siblings('.gazoo-grid');
    		$grid_size = $(this).parent().siblings('.gazoo-grid').find('.gazoo-grid__item').size();

    		$visible_elements_size = $grid.find('.gazoo-grid__item:visible').size();
    		$visible_elements_size = ($visible_elements_size + 6 <= $grid_size) ? $visible_elements_size + 6 : $grid_size;

    		$grid.find('.gazoo-grid__item:lt(' + $visible_elements_size + ')').show();

    		if($visible_elements_size >= $grid_size) {
    			$(this).fadeOut();
    		}

	        // x = (x+9 <= size_grid) ? x+9 : size_grid;
	        // $('#album-images .grid-container .grid-item.image:lt('+x+')').show();

	        // if(x >= size_grid) {
	     	// 	$('.load-more-container.images').fadeOut();   	
	        // }
    	});

	});
	
})(jQuery);


function copyLink(url) {
	navigator.clipboard.writeText(url);
	alert('Link copied to clipboard');
}